import { render, staticRenderFns } from "./prize_statistics.vue?vue&type=template&id=0107e87a&scoped=true"
import script from "./prize_statistics.vue?vue&type=script&lang=js"
export * from "./prize_statistics.vue?vue&type=script&lang=js"
import style0 from "./prize_statistics.vue?vue&type=style&index=0&id=0107e87a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0107e87a",
  null
  
)

export default component.exports